(function () {
  /* ============================================================
     THESIS QUICK CARD V2
     Global quick-add modal controller
     Used by: PDP Style With, future collection cards, future modules
  ============================================================ */

  /* -----------------------------
     1. State
  ----------------------------- */
  let activeProduct = null;
  let activeVariant = null;

  /* -----------------------------
     2. DOM selectors
  ----------------------------- */
  const modal = document.querySelector('[data-thesis-quick-card]');
  if (!modal) return;

  const image = modal.querySelector('[data-thesis-quick-card-image]');
  const title = modal.querySelector('[data-thesis-quick-card-title]');
  const titleLink = modal.querySelector('[data-thesis-quick-card-title-link]');
  const mediaLink = modal.querySelector('[data-thesis-quick-card-link]');
  const viewLink = modal.querySelector('[data-thesis-quick-card-view]');
  const price = modal.querySelector('[data-thesis-quick-card-price]');
  const sizes = modal.querySelector('[data-thesis-quick-card-sizes]');
  const addButton = modal.querySelector('[data-thesis-quick-card-add]');
  const status = modal.querySelector('[data-thesis-quick-card-status]');

  const progress = modal.querySelector('[data-thesis-quick-progress]');
  const current = modal.querySelector('[data-thesis-quick-current]');
  const total = modal.querySelector('[data-thesis-quick-total]');

  const colorsWrap = modal.querySelector('[data-thesis-quick-card-colors]');
  const swatches = modal.querySelector('[data-thesis-quick-card-swatches]');
  const colorName = modal.querySelector('[data-thesis-quick-card-color-name]');
  
  const quickSizeGuideButton = modal.querySelector('[data-thesis-quick-size-guide]');
const quickSizeGuidePanel = modal.querySelector('[data-thesis-quick-size-guide-panel]');
const quickSizeGuideTitle = modal.querySelector('[data-thesis-quick-size-guide-title]');
const quickSizeGuideCategory = modal.querySelector('[data-thesis-quick-size-guide-category]');
const quickSizeGuideChart = modal.querySelector('[data-thesis-quick-size-guide-chart]');
const quickSizeGuideClose = modal.querySelector('[data-thesis-quick-size-guide-close]');

  /* -----------------------------
     3. Small helpers
  ----------------------------- */
  function formatNumber(number) {
    return String(number).padStart(2, '0');
  }

  function getProductUrl(product) {
    return product && (product.url || product.href) ? (product.url || product.href) : '#';
  }

  function setProductLinks(product) {
    const url = getProductUrl(product);

    if (mediaLink) mediaLink.href = url;
    if (titleLink) titleLink.href = url;
    if (viewLink) viewLink.href = url;
  }

  function resetSelectionState() {
    activeVariant = null;

    if (addButton) {
      addButton.textContent = 'select size';
    }

    if (status) {
      status.textContent = '';
    }
  }

function updateQuickSizeGuide(product) {
  const guides = product.sizeGuides && product.sizeGuides.length
    ? product.sizeGuides
    : product.sizeGuide
      ? [product.sizeGuide]
      : [];
  const activeGuideIndex = typeof product._activeSizeGuideIndex === 'number'
  ? product._activeSizeGuideIndex
  : 0;
  const hasChart = guides.some((guide) => guide.chart && guide.chart.trim().length > 0);

  if (!quickSizeGuideButton) return;

  if (!hasChart) {
    quickSizeGuideButton.hidden = true;
    if (quickSizeGuidePanel) quickSizeGuidePanel.hidden = true;
    return;
  }

  quickSizeGuideButton.hidden = false;

  if (quickSizeGuideTitle) {
    quickSizeGuideTitle.textContent = 'size guide';
  }

  if (quickSizeGuideCategory) {
    quickSizeGuideCategory.textContent = guides[0].category || '';
  }

  if (quickSizeGuideChart) {
    quickSizeGuideChart.innerHTML = '';

    if (guides.length > 1) {
      const tabs = document.createElement('div');
      tabs.className = 'thesis-quick-card__size-guide-tabs';

      guides.forEach((guide, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = index === activeGuideIndex ? 'is-active' : '';
        button.textContent = guide.title || guide.category || `guide ${index + 1}`;
        button.dataset.quickSizeGuideTab = String(index);
        tabs.appendChild(button);
      });

      quickSizeGuideChart.appendChild(tabs);
    }

    const units = document.createElement('div');
    units.className = 'thesis-quick-card__size-guide-units';
    units.setAttribute('data-thesis-quick-size-units', '');

    units.innerHTML = `
      <button type="button" class="is-active" data-unit="in">inches</button>
      <button type="button" data-unit="cm">cm</button>
    `;

    quickSizeGuideChart.appendChild(units);

    const tableWrap = document.createElement('div');
    tableWrap.className = 'thesis-quick-card__size-guide-table-wrap';
    quickSizeGuideChart.appendChild(tableWrap);

    function renderGuide(index) {
      const guide = guides[index] || guides[0];

      if (quickSizeGuideCategory) {
        quickSizeGuideCategory.textContent = guide.category || '';
      }

      tableWrap.innerHTML = '';

      const rows = (guide.chart || '')
        .split('\n')
        .map(row => row.trim())
        .filter(row => row.includes('|'))
        .map(row => row.split('|').map(cell => cell.trim()));

      if (rows.length > 1) {
        const table = document.createElement('table');
        table.className = 'thesis-quick-card__size-guide-table';

        rows.forEach((row, rowIndex) => {
          const tr = document.createElement('tr');

          row.forEach((cell, cellIndex) => {
            const el = document.createElement(rowIndex === 0 ? 'th' : 'td');
            el.textContent = cell;

            if (rowIndex !== 0 && cellIndex !== 0) {
              el.dataset.inches = cell;
            }

            tr.appendChild(el);
          });

          table.appendChild(tr);
        });

        tableWrap.appendChild(table);
      } else {
        tableWrap.textContent = guide.chart || '';
      }

      const unitButtons = quickSizeGuideChart.querySelectorAll('[data-thesis-quick-size-units] button');
      unitButtons.forEach((button) => button.classList.remove('is-active'));

      const inchesButton = quickSizeGuideChart.querySelector('[data-thesis-quick-size-units] [data-unit="in"]');
      if (inchesButton) inchesButton.classList.add('is-active');
    }

    renderGuide(activeGuideIndex);
  }

  if (quickSizeGuidePanel && !product._keepPanelOpen) {
  quickSizeGuidePanel.hidden = true;
}
}
  /* -----------------------------
     4. Progress indicator
     Locked thesis style: 01 — 04
  ----------------------------- */
  function renderProgress(product) {
    if (!progress || !current || !total) return;

    const count = product && product.variants ? product.variants.length : 1;

    if (count > 1) {
      progress.hidden = false;
      current.textContent = '01';
      total.textContent = formatNumber(count);
    } else {
      progress.hidden = true;
    }
  }

  function updateProgress(index) {
    if (!current) return;
    current.textContent = formatNumber(index + 1);
  }

  /* -----------------------------
     5. Product content
  ----------------------------- */
  function renderProductContent(product) {
    if (image) {
      image.src = product.image || '';
      image.alt = product.title || '';
    }

    if (title) {
      title.textContent = product.title || '';
    }

    if (price) {
      price.textContent = product.price || '';
    }

    setProductLinks(product);
  }

  /* -----------------------------
     6. Color swatches
     Uses product.colors from data-product.
     Active color is matched by product.id.
  ----------------------------- */
  function renderColors(product) {
    if (!colorsWrap || !swatches) return;

    swatches.innerHTML = '';

    if (!product.colors || !product.colors.length) {
      colorsWrap.hidden = true;
      if (colorName) colorName.textContent = '';
      return;
    }

    colorsWrap.hidden = false;

    const activeColorIndex = product.colors.findIndex((color) => {
      return (
        color.id &&
        product.id &&
        String(color.id) === String(product.id)
      );
    });

    const selectedColorIndex = activeColorIndex > -1 ? activeColorIndex : 0;

    product.colors.forEach((color, index) => {
      const button = document.createElement('button');

      button.type = 'button';
      button.className = 'thesis-quick-card__swatch';
      button.style.setProperty('--swatch-color', color.value || color.hex || '#d8d2c8');
      button.setAttribute('aria-label', color.name || 'color');

      if (index === selectedColorIndex) {
        button.classList.add('is-active');

        if (colorName) {
          colorName.textContent = color.name || '';
        }
      }

      button.addEventListener('click', () => {
  swatches.querySelectorAll('.thesis-quick-card__swatch').forEach((item) => {
    item.classList.remove('is-active');
  });

  button.classList.add('is-active');

  if (colorName) {
    colorName.textContent = color.name || '';
  }

  if (color.image && image) {
    image.src = color.image;
  }

  if (color.url) {
    if (mediaLink) mediaLink.href = color.url;
    if (titleLink) titleLink.href = color.url;
    if (viewLink) viewLink.href = color.url;
  }

 const nextProduct = {
  id: color.id || activeProduct.id,
  title: activeProduct.title,
  url: color.url || activeProduct.url,
  image: color.image || activeProduct.image,
  price: color.price || activeProduct.price,
  variants: color.variants || [],
  colors: activeProduct.colors || [],
  sizeGuide: color.sizeGuide || {},
  sizeGuides: color.sizeGuides || activeProduct.sizeGuides || []
};

  activeProduct = nextProduct;

  renderProductContent(nextProduct);
  renderSizes(nextProduct);
  updateQuickSizeGuide(nextProduct);
  resetSelectionState();
});
      swatches.appendChild(button);
    });
  }

  /* -----------------------------
     7. Size buttons
  ----------------------------- */
  function renderSizes(product) {
    if (!sizes) return;

    sizes.innerHTML = '';

    if (!product.variants || !product.variants.length) return;
    const hasOnlyDefaultVariant =
        product.variants.length === 1 &&
        String(product.variants[0].title).toLowerCase() === 'default title';

    if (hasOnlyDefaultVariant) {
        activeVariant = product.variants[0];
        modal.classList.add('is-no-size-product');

        sizes.closest('.thesis-quick-card__sizes-wrap').hidden = true;

    if (addButton) {
        addButton.textContent = 'add to cart';
    }

        return;
    }
    modal.classList.remove('is-no-size-product');
    sizes.closest('.thesis-quick-card__sizes-wrap').hidden = false;

    product.variants.forEach((variant, index) => {
      const button = document.createElement('button');

      button.type = 'button';
      button.className = 'thesis-quick-card__size';
      button.textContent = variant.title;
      button.dataset.variantId = variant.id;

      if (!variant.available) {
        button.classList.add('is-disabled');
      }

      button.addEventListener('click', () => {
        if (!variant.available) return;

        activeVariant = variant;

        sizes.querySelectorAll('.thesis-quick-card__size').forEach((item) => {
          item.classList.remove('is-active');
        });

        button.classList.add('is-active');

        if (addButton) {
          addButton.textContent = 'add to cart';
        }

        if (status) {
          status.textContent = '';
        }

        updateProgress(index);
      });

      sizes.appendChild(button);
    });
  }

  /* -----------------------------
     8. Open / close modal
  ----------------------------- */
  function openQuickCard(product) {
    activeProduct = product;
    resetSelectionState();

    renderProductContent(product);
    renderProgress(product);
    renderColors(product);
    renderSizes(product);
    updateQuickSizeGuide(product);

    modal.hidden = false;
    document.documentElement.style.overflow = 'hidden';
  }

  function closeQuickCard() {
    modal.hidden = true;
    document.documentElement.style.overflow = '';
  }

  /* -----------------------------
     9. Close events
  ----------------------------- */
  document.addEventListener('click', function (event) {
    const close = event.target.closest('[data-thesis-quick-card-close]');

    if (close) {
      closeQuickCard();
    }
  });


  /* ----------------------------------
   11. Quick Size Guide Panel
----------------------------------- */
document.addEventListener('click', function (event) {
  const openGuide = event.target.closest('[data-thesis-quick-size-guide]');
  const closeGuide = event.target.closest('[data-thesis-quick-size-guide-close]');

  if (openGuide) {
    event.preventDefault();

    if (quickSizeGuidePanel) {
      quickSizeGuidePanel.hidden = false;
    }
  }

  if (closeGuide) {
    event.preventDefault();

    if (quickSizeGuidePanel) {
      quickSizeGuidePanel.hidden = true;
    }
  }
});
document.addEventListener('click', function (event) {
  const unitButton = event.target.closest('[data-thesis-quick-size-units] button');
  if (!unitButton) return;

  const panel = unitButton.closest('[data-thesis-quick-size-guide-panel]');
  if (!panel) return;

  const unit = unitButton.dataset.unit;
  const table = panel.querySelector('.thesis-quick-card__size-guide-table');
  if (!table) return;

  unitButton.parentElement.querySelectorAll('button').forEach((button) => {
    button.classList.remove('is-active');
  });

  unitButton.classList.add('is-active');

  table.querySelectorAll('td').forEach((cell) => {
    if (cell.cellIndex === 0) return;

    const original = cell.dataset.inches || cell.textContent.trim();
    cell.dataset.inches = original;

    const number = parseFloat(original);

    if (!isNaN(number)) {
      cell.textContent = unit === 'cm'
        ? (number * 2.54).toFixed(1)
        : original;
    }
  });
});
document.addEventListener('click', function (event) {
  const tab = event.target.closest('[data-quick-size-guide-tab]');
  if (!tab) return;

  const panel = tab.closest('[data-thesis-quick-size-guide-panel]');
  if (!panel) return;

  const index = Number(tab.dataset.quickSizeGuideTab);
  if (Number.isNaN(index)) return;

  panel.querySelectorAll('[data-quick-size-guide-tab]').forEach((button) => {
    button.classList.remove('is-active');
  });

  tab.classList.add('is-active');

  if (activeProduct) {
    updateQuickSizeGuide({
  ...activeProduct,
  sizeGuides: activeProduct.sizeGuides,
  _activeSizeGuideIndex: index,
  _keepPanelOpen: true
});
  }
});
  /* -----------------------------
     11. Open trigger
  ----------------------------- */
  document.addEventListener('click', function (event) {
    const trigger = event.target.closest('[data-thesis-quick-card-open]');
    if (!trigger) return;

    const raw = trigger.getAttribute('data-product');
    if (!raw) return;

    event.preventDefault();
    event.stopPropagation();

    try {
      const product = JSON.parse(raw);
      openQuickCard(product);
    } catch (error) {
      console.warn('Thesis quick card product data error:', error);
    }
  });

  /* -----------------------------
     12. Add to cart
     Uses the standalone thesis cart drawer (assets/thesis-cart.js).
  ----------------------------- */
  if (addButton) {
    addButton.addEventListener('click', async () => {
      if (!activeVariant || !activeVariant.available) {
        if (addButton) addButton.textContent = 'select size';
        if (status) status.textContent = 'please select a size';
        return;
      }

      try {
        if (addButton) addButton.textContent = 'adding';

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: activeVariant.id,
            quantity: 1
          })
        });

        if (!response.ok) {
          throw new Error('Shopify rejected add to cart: ' + response.status);
        }

        if (addButton) addButton.textContent = 'added';

        closeQuickCard();

        if (window.ThesisCart && typeof window.ThesisCart.refreshAndOpen === 'function') {
          await window.ThesisCart.refreshAndOpen();
        } else {
          window.location.href = '/cart';
        }

      } catch (error) {
        console.warn('Thesis quick card add failed:', error);

        if (addButton) addButton.textContent = 'unavailable';
        if (status) status.textContent = 'unable to add';
      }
    });
  }

  /* -----------------------------
     13. Public API
  ----------------------------- */
  window.ThesisQuickCard = {
    open: openQuickCard,
    close: closeQuickCard
  };
})();
